import ThermomagneticSwitches from "../classes/ThermomagneticSwitch"

export const thermomagneticSwitches = [
  new ThermomagneticSwitches({alias:"acometida", svgSrc: "/symbol-assets/Acometida.svg", label: "Label for Type 1"}),
  new ThermomagneticSwitches({alias:"arco", svgSrc: "/symbol-assets/Arco.svg", label: "Label for Type 2"}),
  new ThermomagneticSwitches({alias:"condensador", svgSrc: "/symbol-assets/Condensador.svg", label: "Label for Type 3"}),
];